<template>
  <div class="color-sample n2-east3">
    <section class="adjust-top">
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box">
        <p class="default-text">
          源頼朝
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section />
    <section class="adjust-top">
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box">
        <p class="default-text">
          源頼朝
        </p>
      </div>
      <div class="box grow" />
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
